import { createVuetify } from "vuetify";
import "@mdi/font/css/materialdesignicons.css";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import PerfectScrollbar from "vue3-perfect-scrollbar";
import VueApexCharts from "vue3-apexcharts";
import VueTablerIcons from "vue-tabler-icons";
import "@/scss/style.scss";
import { OniTheme } from "~/theme/dark-theme";
import { PurpleTheme } from "~/theme/light-theme";
import { computed, h } from "vue";
import { VTextField as _VTextField } from "vuetify/components";

const VTextField = {
  name: "VTextField",
  extends: _VTextField,
  props: _VTextField.props,
  setup(props, ctx) {
    if (props.type !== "datetime-local") {
      return _VTextField.setup(props, ctx);
    }

    const localValue = computed({
      get() {
        const iso = props.modelValue || "";
        if (!iso) return "";
        const d = new Date(iso);
        d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
        return d.toISOString().slice(0, 16);
      },
      set(v) {
        const iso = v ? new Date(v).toISOString() : "";
        ctx.emit("update:modelValue", iso);
      },
    });

    const onPaste = (event) => {
      const text = event.clipboardData?.getData("text") || "";
      const date = new Date(text);
      if (!isNaN(date.getTime())) {
        event.preventDefault();
        ctx.emit("update:modelValue", date.toISOString());
      }
    };

    return () =>
      h(
        _VTextField,
        {
          ...ctx.attrs,
          type: "datetime-local",
          step: ctx.attrs.step ?? 1,
          modelValue: localValue.value,
          "onUpdate:modelValue": (val) => (localValue.value = val),
          onPaste,
        },
        ctx.slots
      );
  },
};

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    components: {
      ...components,
      VTextField,
    },
    directives,
    theme: {
      defaultTheme: "OniTheme",
      themes: { OniTheme, PurpleTheme },
    },
  });

  nuxtApp.vueApp.use(vuetify);
  nuxtApp.vueApp.use(PerfectScrollbar);
  nuxtApp.vueApp.use(VueApexCharts);
  nuxtApp.vueApp.use(VueTablerIcons);
  nuxtApp.vueApp.provide("vuetify", vuetify);
});
